import * as React from "react";
import Modal from "./Modal";
import ModalButtonList from "./ModalButtonList";
import ModalButton from "./ModalButton";
import Context from "./Context";
import ModalText from "./ModalText";

export default class ModalReportResult extends React.Component {

    public render(): React.ReactNode {
        return (
            <Context.Consumer>
                {({dispatch, translate}) => (
                    <Modal>
                        <ModalText>
                            {translate("MODAL_TEXT_REPORT_2")}
                        </ModalText>
                        <ModalButtonList>
                            <ModalButton onClick={() => {
                                dispatch("report/result-close");
                            }}>
                                {translate("MODAL_BUTTON_OK")}
                            </ModalButton>
                        </ModalButtonList>
                    </Modal>
                )}
            </Context.Consumer>
        );
    }

}